import "./GlassSlider.css";

function GlassSlider({ leftLabel = "My Picks", rightLabel = "Difficulty Rating", active = "left", setSelected, configuredLeagueId = 0 }) {
  return (
    <div className="glass-slider-bg">
      <div className="glass-slider">
        <button
          className={`glass-btn ${active === "left" ? "active" : ""}`}
          onClick={() => setSelected("left")}
        >
          {leftLabel}
        </button>
        <button
          className={`glass-btn ${configuredLeagueId === '39' ? "cursor-pointer" : "cursor-not-allowed"} ${active === "right" ? "active" : ""}`}
          disabled={configuredLeagueId !== '39'}
          onClick={() => {
            if (configuredLeagueId === '39') setSelected("right")
          }}
          title={configuredLeagueId !== '39' ? "Only available for EPL League" : ""}
        >
          {rightLabel}
        </button>
      </div>
    </div>
  );
}

export default GlassSlider;
